var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecurringIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "repeat",
    filter: "url(#filter0_b_5902_10445)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.07348 16.9254C6.90848 17.0927 6.63879 17.0936 6.47263 16.9275L4.79077 15.2456C4.35406 14.8089 4.35412 14.1009 4.79089 13.6642L6.47264 11.983C6.63877 11.8169 6.90839 11.818 7.07321 11.9854C7.23629 12.151 7.23523 12.4171 7.07084 12.5814L5.616 14.0356H14.0412C14.6587 14.0356 15.1593 13.535 15.1593 12.9174V11.1005C15.1593 10.8689 15.3471 10.6812 15.5787 10.6812C15.8102 10.6812 15.998 10.8689 15.998 11.1005V12.6379C15.998 13.873 14.9967 14.8742 13.7617 14.8742H5.61683L7.07139 16.3287C7.23592 16.4932 7.23685 16.7597 7.07348 16.9254ZM4.42093 9.54776C4.18912 9.54776 4.00121 9.35984 4.00121 9.12804V7.59104C4.00121 6.35599 5.00241 5.35478 6.23747 5.35478H14.384L12.929 3.89983C12.7647 3.7355 12.7637 3.46939 12.9267 3.3038C13.0916 3.13639 13.3612 3.13535 13.5274 3.30148L15.2093 4.98344C15.646 5.42009 15.646 6.12806 15.2093 6.56472L13.5278 8.24625C13.3615 8.41254 13.0915 8.41131 12.9267 8.24351C12.7641 8.07786 12.7653 7.81207 12.9295 7.6479L14.384 6.19338H5.95878C5.34126 6.19338 4.84065 6.69398 4.84065 7.3115V9.12804C4.84065 9.35984 4.65274 9.54776 4.42093 9.54776Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_5902_10445",
    x: -16.6667,
    y: -16.6667,
    width: 53.3333,
    height: 53.3333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 8.33333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_5902_10445"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_5902_10445",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecurringIcon);
export default __webpack_public_path__ + "static/media/RecurringIcon.9efda7567a350547aba4c3068e65b654.svg";
export { ForwardRef as ReactComponent };